// Weekday numbers are 0 = Monday ... 6 = Sunday, the same numbering the API
// uses for working hours, coverage and digest days.
export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

// After a delete the current page can be left empty while earlier pages still
// have rows. Returns the last page to go back to, or 0 when the page is fine.
export function pageToStepBackTo({ results, total }, page, pageSize) {
  if (results.length || page <= 1 || total <= 0) return 0;
  return Math.max(1, Math.ceil(total / pageSize));
}

export const isValidTime = value => TIME_PATTERN.test(String(value || ''));
export const isValidDate = value => DATE_PATTERN.test(String(value || ''));

// The API returns seven rows; a day never saved comes back closed with null
// times. Fill in any missing weekday so the form always has seven rows.
export function normalizeWorkingHours(rows) {
  return WEEKDAYS.map(weekday => {
    const row = (rows || []).find(r => r.weekday === weekday);
    return {
      weekday,
      is_open: row ? !!row.is_open : false,
      start: row && row.start ? row.start : '09:00',
      end: row && row.end ? row.end : '18:00',
    };
  });
}

// Returns { weekday: 'END_AFTER_START' | 'TIME' } for open days only. A closed
// day is sent with null times, which is what the API stores.
export function validateWorkingHours(rows) {
  const errors = {};
  rows.forEach(row => {
    if (!row.is_open) return;
    if (!isValidTime(row.start) || !isValidTime(row.end)) {
      errors[row.weekday] = 'TIME';
    } else if (row.start >= row.end) {
      errors[row.weekday] = 'END_AFTER_START';
    }
  });
  return errors;
}

export function workingHoursPayload(rows) {
  return rows.map(row => ({
    weekday: row.weekday,
    is_open: row.is_open,
    start: row.is_open ? row.start : null,
    end: row.is_open ? row.end : null,
  }));
}

// SLA minutes shown as the largest tidy unit. Working-hours tiers say so,
// because their minutes are working minutes. The caller renders the copy.
export function describeMinutes(minutes, basis) {
  const working = basis !== '24x7';
  if (minutes === 0) return { unit: 'NOW', value: 0, working };
  if (working && minutes >= 1440 && minutes % 1440 === 0) {
    return { unit: 'DAYS', value: minutes / 1440, working };
  }
  if (minutes % 60 === 0) {
    return { unit: 'HOURS', value: minutes / 60, working };
  }
  return { unit: 'MINUTES', value: minutes, working };
}

export const TIER_STYLE = {
  T0: 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100',
  T1: 'bg-amber-100 text-amber-700 dark:bg-amber-900/60 dark:text-amber-300',
  T2: 'bg-woot-100 text-woot-700 dark:bg-woot-900 dark:text-woot-300',
  T3: 'bg-slate-100 text-slate-600 dark:bg-slate-600 dark:text-slate-300',
};
